import classnames from "classnames";
import React from "react";

import "./productLabel.scss";

type Props = {
    text: string;
    secondary?: string;
    size?: "md" | "sm" | "xs";
};

const ProductRibbonLabel = ({ text, secondary, size = "md" }: Props) => (
    <>
        <span
            className={classnames(
                "product-label",
                "product-label--ribbon",
                secondary && "product-label__secondary",
                size === "sm" && "product-label--small",
                size === "xs" && "product-label--extra-small",
            )}
        >
            <span
                className={classnames(
                    "text pl-3",
                    size === "md" ? "p-2" : "p-1",
                    "pr-2"
                )}
            >
                {text}
            </span>
            {secondary && (
                <span
                    className={classnames(
                        "secondary",
                        size === "md" ? "p-2" : "p-1",
                    )}
                >
                    {secondary}
                </span>
            )}
        </span>
    </>
);

export { ProductRibbonLabel };
